import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteNav } from "@/components/site/SiteNav";
import { Contact, Footer } from "@/components/site/Sections";

export const Route = createFileRoute("/contact-us")({
  head: () => ({
    meta: [
      {
        title: "Contact Us — KMWAdvertising LLP",
      },
      {
        name: "description",
        content:
          "Connect with KMWAdvertising LLP for advertising campaigns, media planning, brand strategy, and web development consultations.",
      },
    ],
  }),
  component: ContactUsPage,
});

export function ContactUsPage() {
  return (
    <div className="min-h-screen bg-[#07070d] text-slate-100 selection:bg-amber-500 selection:text-white font-sans relative overflow-x-hidden">
      <SiteNav />
      <div className="pt-24">
        <Contact />
      </div>
      <Footer />
    </div>
  );
}
